"use client"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import type { getDictionary } from "@/get-dictionary"
import { cn } from "@/lib/utils"
import type { JoshType } from "@/models/Josh"
import Link from "@/components/local-link"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useCallback, useMemo } from "react"

type Props = {
  joshArray: JoshType[]
  dictionary: Awaited<ReturnType<typeof getDictionary>>["josh"]
  className?: string
}
export default function JoshFilter({
  dictionary,
  joshArray,
  className,
}: Props) {
  const params = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  const selected = useMemo(() => {
    return params.get("josh") !== null
      ? joshArray.find((e) => e.uid === params.get("josh"))
      : joshArray.at(0)
  }, [joshArray, params])

  const handleChange = useCallback(
    (item: string) => {
      const searchParams = new URLSearchParams(params)
      searchParams.set("josh", item)
      router.push(`${pathname}?${searchParams.toString()}`, {
        scroll: false,
      })
    },
    [params, pathname, router]
  )
  return (
    <div
      className={cn(
        "inline-flex w-full flex-col items-center justify-between gap-2 py-4 sm:flex-row",
        className
      )}
    >
      <div className="inline-flex w-full flex-col items-start gap-2 sm:w-96 sm:flex-row sm:items-center">
        <span className="w-max shrink-0 font-medium">
          {dictionary._filter_label}
        </span>
        <Select defaultValue={selected?.uid} onValueChange={handleChange}>
          <SelectTrigger className="px-2 py-0">
            <SelectValue placeholder="Search by Edition" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup
              ref={(ref) =>
                ref?.addEventListener("touchend", (e) => {
                  e.preventDefault()
                })
              }
            >
              <SelectLabel>Josh</SelectLabel>
              {joshArray.map((item) => (
                <SelectItem
                  key={item.uid}
                  value={item.uid}
                  className="cursor-pointer"
                >
                  {item.title}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      <Link
        // @ts-ignore
        href={selected?.document.url}
        target="_blank"
        className="w-full bg-custom-10 p-2 text-center text-sm font-medium text-secondary sm:w-max sm:rounded-lg"
      >
        {dictionary._download_manual}
      </Link>
    </div>
  )
}
